/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import $ from 'zepto';
import { getXoom } from '../xoom';

const init = () => {
  const xoom = getXoom();
  const SUBMIT = 'submit';
  const INPUT = 'input';
  const PLACEHOLDER = 'placeholder';
  const AUTOFOCUS = 'autofocus';
  const PLACEHOLDER_ACTIVE = `${PLACEHOLDER}-active`;
  const testInputElement = document.createElement(INPUT);

  if (!xoom.form) {
    xoom.form = {};
  }

  xoom.form.init = function (parentElement) {
    let parent;
    const errorClass = 'error';
    const hasErrorsClass = 'has-errors';
    const jsDisableAutoSubmitDisable = 'js-disable-auto-submit-disable';
    const buttonSelector = `.ui-action-tag:not(.${jsDisableAutoSubmitDisable})`;
    const DISABLED = 'disabled';
    const OPACITY = 'opacity';

    if (!parentElement) {
      parent = $('body');
    } else {
      parent = $(parentElement);
    }

    function enableSubmitButtons($form, $buttons) {
      if (!$form.hasClass('in-error')) {
        $buttons.removeAttr(DISABLED).css(OPACITY, '1.0');
      }
    }

    // disable the form buttons when form is submitted.
    $('form:not(.js-prevent-global-form-handler)', parent)
      .bind('submit', function () {
        const $form = $(this);
        const $buttons = $(buttonSelector, $form);

        if (!$form.hasClass(jsDisableAutoSubmitDisable)) {
          $buttons.attr(DISABLED, DISABLED).css(OPACITY, '0.5');
          setTimeout(() => {
            enableSubmitButtons($form, $buttons);
          }, 30000);
        }
      })
    // re-enable submit button(s) once client-side validation passes
      .bind('enable-submit', function () {
        const $form = $(this);
        const $buttons = $(buttonSelector, $form);
        enableSubmitButtons($form, $buttons);
      });

    // remove red border error indicator when user changes field input
    // TODO: Update flow pages and custom pulldown to use has-errors paradigm
    // that profile pages use and remove conditional below
    $(`input.${errorClass}, .${hasErrorsClass} input`, parent).bind('keyup keydown', function (event) {
      const $this = $(this);
      let className = errorClass;
      const keyCode = event.which;

      // exit if key code is that of a tab or arrow
      if ((keyCode === 9 && $this.val() === '') || (keyCode >= 37 && keyCode <= 40)) {
        return;
      }

      if (!($this.hasClass(errorClass)) && $(`.${hasErrorsClass}`).length) {
        className = hasErrorsClass;
      }
      remove_error_class($this, className);
    });

    $(`.${hasErrorsClass} input[type=radio]`, parent).change(function () {
      remove_error_class($(this), hasErrorsClass);
    });

    $('select', parent).change(function () {
      let errorClassToRemove = '';
      const pulldownSelectors = '#{0}-fld .customSelect, #{0}custom-pulldown';

      if ($(this).hasClass(errorClass)) {
        errorClassToRemove = errorClass;
      } else if ($(this).closest('.xform-row').hasClass(hasErrorsClass)) {
        errorClassToRemove = hasErrorsClass;
      }

      if (errorClassToRemove !== '') {
        remove_error_class($(pulldownSelectors.replaceTokens(this.id.replace(/\./g, '\\.'))), errorClassToRemove);
      }
    });

    function remove_error_class(elements, className) {
      if (className === hasErrorsClass) {
        elements = elements.closest(`.${hasErrorsClass}`);
      }
      elements.removeClass(className);
    }

    // bind country selection event handler
    $('.auto-submit', parent).bind('change', (event) => {
      $(event.target.form).submit();
    });

    // add HTML5 placeholder text support to browsers that do not support it
    function supports_input_placeholder() {
      return PLACEHOLDER in testInputElement;
    }

    // add HTML5 autofocus text support to browsers that do not support it
    function supports_input_autofocus() {
      return AUTOFOCUS in testInputElement;
    }

    const localSetTimeout = setTimeout;
    if (!supports_input_placeholder()) {
      localSetTimeout(() => {
        $(`${INPUT}[${PLACEHOLDER}]:not([dataSuppressIE8CustomPlaceholder='true'])`, parentElement).each(function () {
          const $input = $(this);
          const placeholderTextActiveClass = PLACEHOLDER_ACTIVE;
          let placeholderText = $input.attr(PLACEHOLDER);
          const inputType = $input.attr('type');
          let ieIsLameTimeout;

          function checkPlaceholderValue() {
            const currentPlaceholderText = $input.attr(PLACEHOLDER);
            if (placeholderText !== currentPlaceholderText) {
              // placeholder was updated dynamically.  Update field.
              if ($input.val() === placeholderText) {
                $input.val(currentPlaceholderText);
              }
              placeholderText = currentPlaceholderText;
            }
          }

          function clearHintText() {
            checkPlaceholderValue();

            if ($input.val() === placeholderText) {
              $input
                .val('')
                .removeClass(placeholderTextActiveClass);
            }
          }

          function setHintText() {
            clearTimeout(ieIsLameTimeout);
            ieIsLameTimeout = localSetTimeout(() => {
              checkPlaceholderValue();

              if ($input.val() === '') {
                $input
                  .addClass(placeholderTextActiveClass)
                  .val(placeholderText);
              } else {
                $input.removeClass(placeholderTextActiveClass);
              }
            }, 100);
          }

          if (placeholderText && (inputType !== 'password')) {
            $input.bind('focus', clearHintText)
              .bind('blur', setHintText)
              .bind('change', setHintText)
              .bind('update', checkPlaceholderValue);

            $($input[0].form).bind(SUBMIT, clearHintText);

            setHintText();
          }
        });
      }, 10);
    } else {
      parent.addClass('placeholder');
    }

    if (!supports_input_autofocus()) {
      setTimeout(() => {
        $(`${INPUT}[${AUTOFOCUS}]`).each(function () {
          $(this).focus();
        });
      }, 500);
    }

    // :checked polyfill
    // used only for IE8
    (function checkedPolyfill() {
      const CHECKED = 'checked';

      function refresh() {
        const self = this;
        const { name } = self;

        /* Refresh the UI for all radio buttons that have the same name as the one specified by the ID */
        /* this is all for IE8 */
        const inputElementSelector = `input[name=${name}]`;
        const RADIO_UPDATED = 'element-updated';

        /* Remove all 'checked' and 'disabled' classes */
        $(inputElementSelector, parent).removeClass(`${CHECKED} ${DISABLED}`);

        /* add 'checked' class to any inputs that are currently checked */
        $(`${inputElementSelector}:${CHECKED}`, parent).addClass(CHECKED);

        /* add 'disabled' class to any inputs that are currently disabled */
        $(`${inputElementSelector}:${DISABLED}`, parent).addClass(DISABLED);

        /* Stupid thing I have to do to make sure IE refreshes the layout, without this, you don't see changes
                                 * until you move your mouse off the label */
        $(self).parents('form').addClass(RADIO_UPDATED).removeClass(RADIO_UPDATED);
      }

      // IE8 :checked polyfill
      if ($('html').hasClass('ie8')) {
        // for IE8 and below, add and remove classes
        $("input[type='radio'], input[type='checkbox']", parent).not(`:${DISABLED}`)
          .bind('change', refresh)
          .each(refresh);
      }
    }());
  };

  /**
         Serialize specified form.
         Custom:  omit the value of any form elements that have "placeholder-active" class name (IE).

         @method serialize
         @param {String} formSelector String specifying the form to be serialized
         @return {String} Serialized form
         @public
         */
  xoom.form.serialize = function (formSelector) {
    const $elements = $('input, select, textarea', $(formSelector));
    const nameValuePairs = [];

    $elements.each(function () {
      const $element = $(this);
      const { type } = this;
      let val = $element.val();
      let includeField = true;

      if ($element.hasClass(PLACEHOLDER_ACTIVE)) {
        // zap out the value if the element has "placeholder-active" class
        val = '';
      }

      // exclude radios and checkboxes if they are not "checked"
      if (type && (type === 'checkbox' || type === 'radio') && !this.checked) {
        includeField = false;
      }

      if (this.name === '') {
        includeField = false;
      }

      if (includeField) {
        nameValuePairs.push([this.name, encodeURIComponent(val)].join('='));
      }
    });

    return nameValuePairs.join('&');
  };

  $(document).ready(() => {
    xoom.form.init();
  });
  return xoom;
};

export default init;
